/**
 * ExecPro360 - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
import { PUBLISHER_LABEL, COPYRIGHT_YEAR } from "../config/legal";

// Liens légaux : pages publiques ouvertes dans un nouvel onglet (même
// gabarit que pour un visiteur, sans quitter l'application).
export default function Footer() {
  const linkStyle = {
    color: '#475569', cursor: 'pointer', fontSize: 10, padding: '0 4px',
    textDecoration: 'underline',
  };

  return (
    <div style={{
      textAlign: "center",
      padding: "6px 0 8px",
      fontSize: 10,
      color: "#475569",
      borderTop: "0.5px solid var(--border, #1e293b)",
      userSelect: "none",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
      flexWrap: 'wrap',
    }}>
      <span>© {COPYRIGHT_YEAR} {PUBLISHER_LABEL} · ExecPro360 · Tous droits réservés</span>
      <span>·</span>
      <a style={linkStyle} href="/mentions-legales" target="_blank" rel="noopener noreferrer">Mentions légales</a>
      <span>·</span>
      <a style={linkStyle} href="/confidentialite" target="_blank" rel="noopener noreferrer">Confidentialité</a>
      <span>·</span>
      <a style={linkStyle} href="/cgu" target="_blank" rel="noopener noreferrer">CGU</a>
    </div>
  );
}
